{
  "id": 31,
  "location": "paris",
  "difficulty": "normal",
  "moves": 23,
  "kinds": 6,
  "goals": [
    { "type": "collect", "kind": "cupcake", "count": 36 },
    { "type": "collect", "kind": "macaron", "count": 36 }
  ],
  "stars": [4610, 5700],
  "board": [
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . ."
  ],
  "calibration": { "runs": 1000, "winRate": 0.718, "movesLeft": 4.7, "closeLosses": 0.097, "target": 0.68 }
}
